import {ItemTrackingData} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/item_tracking_data.types';
import {
  TrackingBasicElementContext,
  TrackingBasketItem,
  trackBasketAction,
} from '@aboutyou/legacy-tracking-sdk';
import {ImageTrackingData} from '../utils/getImageTrackingData';
import {getNewTrackingBasketItem} from '../utils/getTrackingBasketItem';
import {getSections} from '../utils/trackingProductGetter';
import {Brand} from '../utils/types';
import {useTracking} from '../utils/utils';

export const useTrackNewBasketAction = () => {
  const {TrackingClient} = useTracking();

  return ({
    type,
    itemTrackingData,
    brand,
    sizeLabel,
    badges,
    imageTrackingData,
  }: {
    type: 'add-to-basket' | 'quantity-update' | 'removed-from-basket';
    itemTrackingData: ItemTrackingData;
    brand: Brand;
    sizeLabel: string;
    badges: string[];
    imageTrackingData?: ImageTrackingData;
  }) => {
    const {section} = getSections();
    const elementData = {
      type: 'element-context',
      rowIndexInSection: 1,
      columnIndexInSection: 1,
      elementIndexInSection: 1,
      productIndexOnPage: 1,
    } as TrackingBasicElementContext;

    const trackingBasketItem: TrackingBasketItem = getNewTrackingBasketItem(
      itemTrackingData,
      brand,
      sizeLabel,
      imageTrackingData,
    );

    TrackingClient.track(
      trackBasketAction({
        type,
        section,
        element: elementData,
        basketItem: trackingBasketItem,
        badges,
      }),
    );
  };
};
